import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let requestToForward = req;

        if (environment.userKey !== '' && environment.tenantId !== '') {
            requestToForward = req.clone({ setHeaders: { 'userKey': environment.userKey,  'tenantId': environment.tenantId }});
        }

        return next.handle(requestToForward);
    }
}
